import { SearchModality } from '@aibees/elephant/feature/search-table-company/hooks/types';
import { useSearchModality } from '@aibees/elephant/hooks';
import { useGetCreditsAmountTypeOnActionPopup } from '@aibees/elephant/hooks/use-get-credits-amount-type-on-action-popup';
import { classnames } from '@aibees/shared/utils';
import { AlertTitle, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ExportWarningSavedProps as Props } from './types';

export const ExportWarningSaved = memo(({ className }: Props) => {
  const { modality } = useSearchModality();
  const { basicPeople, aiPeople } = useGetCreditsAmountTypeOnActionPopup();

  const saved = modality === SearchModality.SAVED;
  const shouldShow = (basicPeople || aiPeople) && saved;

  if (!shouldShow) {
    return null;
  }

  return (
    <Styled.Wrapper
      className={classnames('ExportWarningSaved', className)}
      sx={SX.root}
      severity="default"
      variant="outlined"
    >
      <AlertTitle sx={{ fontSize: '14px', fontWeight: 'bold' }}>
        Before you hit Export pulls your current Saved Records
      </AlertTitle>

      <Stack>
        <Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              If your Records still need updates?
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1} ml={2}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Click Cancel.
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Open Enrich ▸ and run
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1} ml={2}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Update Job Changes,
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1} ml={2}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Update Profile Insights
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1} ml={2}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Run Email Enrichment & Re-Verification.{' '}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            <Styled.Dot />
            <Typography variant="body4" fontWeight={400} color="grey.600">
              Done recently? Skip these steps—you’re good to export.{' '}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Styled.Wrapper>
  );
});

ExportWarningSaved.displayName = 'ExportWarningSaved';
